import React from "react";
import Layout from "./Layout";

export default () => <Layout />

